import store from '@/store'

import {API_BASE, apiErrorHandler, ApiFilter, isDefinedAndNotNull, isNotEmpty} from '../api'
import {objectToSnakeCase} from '../utils'
import Auth from '../auth'

const NOMINATIONS_ENDPOINT = `${API_BASE}nomination/`
const ADMIN_NOMINATIONS_ENDPOINT = `${API_BASE}admin/nomination/`

export default class NominationsApi {
  constructor(cls) {
    this.cls = cls
  }

  static create(cls) {
    return new NominationsApi(cls)
  }

  list({pagination, filters}) {
    const filtersMap = {
      // Pagination
      page: ApiFilter.create({key: 'page'}),
      pageSize: ApiFilter.create({key: 'page_size'}),

      // Sorting
      ordering: ApiFilter.create({key: 'ordering'}),

      // Filtering
      statuses: ApiFilter.create({
        key: 'status',
        validators: [isDefinedAndNotNull, isNotEmpty],
        extractor: l => l.join(','),
      }),
      subOrganizations: ApiFilter.create({
        key: 'sub_organization',
        validators: [isDefinedAndNotNull, isNotEmpty],
        extractor: l => l.join(','),
      }),
      startDate: ApiFilter.create({key: 'start_date'}),
      endDate: ApiFilter.create({key: 'end_date'}),
      nomineeFullName: ApiFilter.create({key: 'nominee_full_name'}),
      organizations: ApiFilter.create({
        key: 'organization',
        validators: [isDefinedAndNotNull, isNotEmpty],
        extractor: l => l.join(','),
      }),
    }
    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
      params: ApiFilter.buildParams(filtersMap, {...pagination, ...filters}),
    }

    const promise = store.state.axiosApi.get(`${NOMINATIONS_ENDPOINT}`, options)
    return promise
      .then(response => response.data)
      .then(data => {
        return {
          ...data,
          results: data.results.map(this.cls.fromAPI),
        }
      })
      .catch(
        apiErrorHandler({
          apiName: 'List Nominations API error',
          rethrowErrors: true,
        }),
      )
  }
}
